<template>
  <div>
    <vx-card>
      <heading size="h1" style-size="h4" class="mb-5">WHS (Workplace Health and Safety)</heading>

      <div class="vs-row" style="display: flex; width: 100%">
        <div class="vs-col vs-xs-12 vs-sm-8 vs-lg-9">
          <p class="mb-5">Why Is Workplace Safety So Important?</p>
          <p class="mb-5">
            There are many reasons why workplace safety is so important. However, the main reasons
            why such a heavy emphasis is placed on safety in the workplace is to:
          </p>
          <ul class="default-list">
            <li>Protect employee and employer safety</li>
            <li>Reduce litigation and insurance costs</li>
            <li>Maximise productivity</li>
            <li>Protect a company’s future as well as employee job security</li>
          </ul>
          <p class="mb-5">
            WHS is everyone’s responsibility. The employer has a responsibility to you, and you have
            a responsibility to your employer and your co-workers.
          </p>
          <p class="mb-5">
            Every job and workplace has unique duties and responsibilities, safety concerns, and
            hazards.
          </p>
          <p class="mb-5">
            The person/company you are doing work experience with is responsible for consulting with
            you on workplace safety.
          </p>
          <p class="mb-5">
            By now, you should have completed a WHS quiz and uploaded your certificate. If you have
            not, please do so
            <router-link
              to="/student/workplace-safety#quiz"
              aria-label="Go to the workplace safety quiz"
              >HERE</router-link
            >, but remember to SAVE your work
          </p>
        </div>
        <div class="vs-col vs-xs-12 vs-sm-4 vs-lg-3 lg:pl-10 sm:pl-5">
          <img
            src="@/assets/images/workplace_preparation/new/whs.jpg"
            class="img-responsive"
            alt=""
          />
        </div>
      </div>

      <form id="form" class="mt-10" @submit.prevent="save">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-checkbox v-model="data.confirmed" name="confirmed"
              >I have read all the information in this module</vs-checkbox
            >
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full flex justify-between">
            <div>
              <button class="btn btn-primary btn-size-medium mr-3 mb-1">Submit</button>
              <router-link
                to="/student/workplace-preparation"
                class="btn btn-secondary btn-size-medium mb-1"
              >
                Back
              </router-link>
            </div>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
export default {
  computed: {
    data: {
      get: function () {
        return this.getModuleData();
      },
      set: function (d) {
        this.setModuleData(d);
      },
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isConfirmed() {
      return this.$store.getters['authStudent/preworkWorkplacePreparationModules'][
        this.$route.params.id
      ];
    },
    prework() {
      return this.$store.getters['authStudent/prework'];
    },
  },
  methods: {
    save() {
      this.saveModule(this.data);
    },
  },
  watch: {
    'prework.workplace_preparation_modules'() {
      const modules = this.prework.workplace_preparation_modules;
      if (modules && modules[5]) {
        this.data = modules[5];
      }
    },
  },
  mounted() {
    if (this.isConfirmed) this.data.confirmed = true;
  },
  beforeDestroy() {
    this.data.confirmed = false;
  },
  inject: ['saveModule', 'getModuleData', 'setModuleData'],
};
</script>
